// src/HomeAssociados.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { FaShoppingCart, FaQrcode, FaIdCard, FaMoneyBill, FaHome, FaBell, FaMoneyBillAlt, FaListAlt } from 'react-icons/fa';
import ButtonSquad from '../components/ButtonSquad';
import api from '../services/api';
import io from 'socket.io-client';

const InterfaceAssociados = () => {
  const navigate = useNavigate();
  const [colunas, setColunas] = useState(getGridColumns());
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [notificacoes, setNotificacoes] = useState([]);
  const [socket, setSocket] = useState(null);
  const [saldo, setSaldo] = useState(0);
  const user = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    // Carregar notificações iniciais
    carregarNotificacoes();
    
    // Carregar saldo inicial
    carregarSaldo();

    // Configurar Socket.io
    const token = localStorage.getItem('token');
    if (token) {
      const newSocket = io('https://app.olympicbarbacena.com.br', {
        auth: {
          token: token
        },
        transports: ['websocket', 'polling']
      });

      newSocket.on('connect', () => {
        console.log('✅ Conectado ao servidor de notificações');
      });

      newSocket.on('disconnect', () => {
        console.log('❌ Desconectado do servidor');
      });

      newSocket.on('connect_error', (error) => {
        console.error('❌ Erro de conexão:', error);
      });
      newSocket.onAny((eventName, ...args) => {
        console.log(`📡 Evento recebido: ${eventName}`, args);
      });
      // Ouvir novas notificações
      newSocket.on('updateOnlineConnections', (novaNotificacao) => {
        console.log('📢 Nova notificação recebida:', novaNotificacao);
        setNotificacoes(prev => [{
          id: novaNotificacao.id || Date.now() + Math.random(),
          mensagem: novaNotificacao.mensagem,
          tipo: novaNotificacao.tipo || 'info',
          timestamp: novaNotificacao.timestamp || new Date(),
          lida: false
        }, ...prev]);
      });

      newSocket.on('notification', (novaNotificacao) => {
        console.log('📢 Nova notificação recebida:', novaNotificacao);
        setNotificacoes(prev => [{
          id: novaNotificacao.id || Date.now() + Math.random(),
          mensagem: novaNotificacao.mensagem,
          tipo: novaNotificacao.tipo || 'info',
          timestamp: novaNotificacao.timestamp || new Date(),
          lida: false
        }, ...prev]);
      });

      // Ouvir atualizações de saldo
      newSocket.on('saldo:update', (data) => {
        console.log('💰 Saldo atualizado via socket:', data.saldo);
        setSaldo(data.saldo);
      });

      newSocket.on('balance:update', (data) => {
        console.log('💰 Balance updated via socket:', data.balance);
        setSaldo(data.balance);
      });

      setSocket(newSocket);

      return () => {
        newSocket.close();
      };
    }

    const handleResize = () => {
      setColunas(getGridColumns());
      setIsMobile(window.innerWidth < 900);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const carregarNotificacoes = async () => {
    try {
      const token = localStorage.getItem('token');
        console.log('🔐 Token disponível:', !!token);
        console.log('👤 User do localStorage:', user);
      const response = await api.get('/notificacoes/my-notifications');
      if (response.data.success) {
        const notifs = response.data.notificacoes.map(notif => ({
          id: notif._id,
          mensagem: notif.mensagem,
          tipo: notif.tipo,
          timestamp: notif.createdAt,
          lida: notif.lida
        }));
        setNotificacoes(notifs);
      }
    } catch (error) {
      console.error('Erro ao carregar notificações:', error);
      // Notificações de exemplo caso a API não esteja disponível
      setNotificacoes([
        { 
          id: 1, 
          mensagem: 'Bem-vindo ao Olympic Club!', 
          lida: false,
          tipo: 'info',
          timestamp: new Date()
        },
        { 
          id: 2, 
          mensagem: 'Confira nosso novo cardápio', 
          lida: true,
          tipo: 'info',
          timestamp: new Date()
        }
      ]);
    }
  };

const carregarSaldo = async () => {
  try {
    if (user && user._id) {
      const token = localStorage.getItem('token');
      const response = await fetch(`https://app.olympicbarbacena.com.br/api/minha-conta/saldo?userId=${user._id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      console.log('💰 Resposta do saldo:', response);

      if (response.ok) {
        // EXTRAIR OS DADOS DA RESPOSTA
        const data = await response.json();
        console.log('💰 Dados do saldo:', data);
        
        // Verificar diferentes formatos possíveis de resposta
        const saldo = data.saldo || data.balance || data.valor || 0;
        setSaldo(saldo);
        console.log('💰 Saldo definido:', saldo);
      } else {
        console.error('❌ Erro ao carregar saldo:', response.status);
        const errorText = await response.text();
        console.error('❌ Detalhes do erro:', errorText);
        setSaldo(0);
      }
    }
  } catch (error) {
    console.error('❌ Erro ao carregar saldo:', error);
    setSaldo(0);
  }
};

  const handleFecharNotificacao = async (id, e) => {
    e.stopPropagation();
    
    try {
      // Tentar marcar como lida no servidor
      await api.patch(`/notificacoes/${id}/ler`);
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
    
    // Remover da lista local independente do sucesso da API
    setNotificacoes(prev => prev.filter(notif => notif.id !== id));
  };

  const marcarComoLida = async (id) => {
    try {
      await api.patch(`/notificacoes/${id}/ler`);
      setNotificacoes(prev => prev.map(notif => 
        notif.id === id ? { ...notif, lida: true } : notif
      ));
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
      // Marcar como lida localmente mesmo se a API falhar
      setNotificacoes(prev => prev.map(notif => 
        notif.id === id ? { ...notif, lida: true } : notif
      ));
    }
  };

  const handleResize = () => {
    setColunas(getGridColumns());
    setIsMobile(window.innerWidth < 900);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${colunas}, 1fr)`,
    gap: isMobile ? '16px' : '30px',
    width: '100%',
    maxWidth: '900px',
    margin: isMobile ? '0 auto' : '0',
    padding: isMobile ? '0 20px' : '0 40px',
  };

  const botoes = [
    { 
      texto: 'Carteirinha QR Code', 
      rota: '/member/carteirinha', 
      icon: FaQrcode,
      gradient: 'linear-gradient(135deg, #2675d5ff 0%, #70aeffff 100%)'
    },
    { 
      texto: `Saldo R$ ${saldo.toFixed(2)}`, 
      rota: '/member/saldo', 
      icon: FaMoneyBillAlt,
      gradient: 'linear-gradient(135deg, #20b258ff 0%, #48D1CC 100%)'
    },
    { 
      texto: 'Pedido Lanchonete', 
      rota: '/enviarpedido', 
      icon: FaShoppingCart,
      gradient: 'linear-gradient(135deg, #ff5650ff 0%, #FFA07A 100%)'
    },
    { 
      texto: 'Acompanhar Pedido', 
      rota: '/member/acompanhar-pedido', 
      icon: FaListAlt,
      gradient: 'linear-gradient(135deg, #ddc74cff 0%, #f7dd5bff 100%)'
    },
  ];

  const notificacoesNaoLidas = notificacoes.filter(notif => !notif.lida).length;

  return (
    <Layout 
      title={
        <div style={styles.titleContainer} >
          {isMobile && (
            <div style={styles.logoMobile}>
              <img 
                src="/logo.png" 
                alt="Logo Olympic Club" 
                style={styles.logoImage}
                onError={(e) => {
                  console.log('Erro ao carregar logo');
                  e.target.style.display = 'none';
                }}
              />
            </div>
          )}
          <div style={styles.welcomeText}>
            <div style={styles.welcomeTitle}>Bem-vindo(a)</div>
            <div style={styles.userName}>{user?.name || 'Associado'}</div>
          </div>
        </div>
      } 
      showBackButton={false} // ← Aqui você define a prop
    >
      <div style={styles.container}>
        {/* Status da Conexão */}
        {/* <div style={styles.statusContainer}>
          <div style={{
            ...styles.statusIndicator,
            backgroundColor: socket?.connected ? '#48BB78' : '#E53E3E'
          }}>
            {socket?.connected ? '✅ Online' : '❌ Offline'}
          </div>
        </div> */}

        {/* Seção de Notificações */}
        <div style={styles.notificacoesContainer}>
          <div style={styles.notificacoesHeader}>
            <FaBell size={20} color="#1A3B7D" />
            <span style={styles.notificacoesTitle}>Notificações</span>
            {notificacoesNaoLidas > 0 && (
              <span style={styles.notificacoesBadge}>{notificacoesNaoLidas}</span>
            )}
          </div>
          
          <div style={styles.notificacoesList}>
            {notificacoes.length > 0 ? (
              notificacoes.slice(0, 3).map((notif) => (
                <div 
                  key={notif.id} 
                  style={{
                    ...styles.notificacaoItem,
                    ...(notif.lida ? styles.notificacaoLida : styles.notificacaoNaoLida),
                    borderLeftColor: getNotificationColor(notif.tipo)
                  }}
                  onClick={() => marcarComoLida(notif.id)}
                >
                  <div style={styles.notificacaoContent}>
                    <div style={{
                      ...styles.notificacaoDot,
                      backgroundColor: getNotificationColor(notif.tipo)
                    }}></div>
                    <span style={styles.notificacaoTexto}>{notif.mensagem}</span>
                    <span style={styles.notificacaoTime}>
                      {formatTime(notif.timestamp)}
                    </span>
                  </div>
                  <button 
                    onClick={(e) => handleFecharNotificacao(notif.id, e)}
                    style={styles.fecharButton}
                    title="Fechar notificação"
                  >
                    <span style={styles.fecharX}>×</span>
                  </button>
                </div>
              ))
            ) : (
              <div style={styles.semNotificacoes}>
                <FaBell size={24} color="#A0AEC0" />
                <div>Nenhuma notificação no momento</div>
              </div>
            )}
          </div>

          {notificacoes.length > 3 && (
            <div style={styles.verMaisContainer}>
              <button 
                style={styles.verMaisButton}
                onClick={() => navigate('/member/notificacoes')}
              >
                Ver todas as notificações ({notificacoes.length})
              </button>
            </div>
          )}
        </div>

        {/* Grid de Botões */}
        <div style={styles.gridContainer}>
          <div style={gridStyle}>
            {botoes.map((botao, index) => (
              <ButtonSquad
                key={index}
                texto={botao.texto}
                icon={botao.icon}
                onClick={() => navigate(botao.rota)}
                isMobile={isMobile}
                gradient={botao.gradient}
              />
            ))}
          </div>
        </div>

        {/* Informações do Usuário */}
        <div style={styles.userInfo}>
          <div style={styles.userCard}>
            <div style={styles.userInfoItem}>
              <strong>Associado:</strong> {user?.associadoId || 'N/A'}
            </div>
            <div style={styles.userInfoItem}>
              <strong>Saldo atual:</strong> R$ {saldo.toFixed(2)}
            </div>
            <div style={styles.userInfoItem}>
              <strong>Status:</strong> {socket?.connected ? 'Conectado' : 'Desconectado'}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

// Funções auxiliares
const getGridColumns = () => {
  const largura = window.innerWidth;
  if (largura < 600) return 2;
  if (largura < 900) return 2;
  return 3;
};

const getNotificationColor = (tipo) => {
  switch (tipo) {
    case 'urgente': return '#E53E3E';
    case 'alerta': return '#ED8936';
    case 'sucesso': return '#38A169';
    default: return '#3182CE';
  }
};

const formatTime = (timestamp) => {
  const date = new Date(timestamp);
  const now = new Date();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMs / 3600000);
  
  if (diffMins < 1) return 'Agora';
  if (diffMins < 60) return `${diffMins}m`;
  if (diffHours < 24) return `${diffHours}h`;
  
  return date.toLocaleDateString('pt-BR');
};

const styles = {
  container: {
    width: '100%',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    padding: '20px 0',
  },
  statusContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '15px',
  },
  statusIndicator: {
    padding: '8px 16px',
    borderRadius: '20px',
    color: 'white',
    fontWeight: '600',
    fontSize: '14px',
    fontFamily: 'Montserrat, sans-serif',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
  },
  logoMobile: {
    width: '60px',
    height: '60px',
  },
  logoImage: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    objectFit: 'cover',
    border: '3px solid #1A3B7D',
  },
  welcomeText: {
    display: 'flex',
    flexDirection: 'column',
  },
  welcomeTitle: {
    fontSize: '14px',
    color: '#718096',
    fontWeight: '500',
    fontFamily: 'Montserrat, sans-serif',
  },
  userName: {
    fontSize: '16px',
    color: '#1A3B7D',
    fontWeight: '600',
    marginTop: '2px',
    fontFamily: 'Montserrat, sans-serif',
  },
  notificacoesContainer: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    margin: '0 auto 30px auto',
    maxWidth: '900px',
    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e2e8f0',
  },
  notificacoesHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    marginBottom: '20px',
    fontWeight: '600',
    color: '#1A3B7D',
    fontSize: '18px',
    fontFamily: 'Montserrat, sans-serif',
  },
  notificacoesTitle: {
    fontFamily: 'Montserrat, sans-serif',
    fontWeight: '600',
  },
  notificacoesBadge: {
    backgroundColor: '#e53e3e',
    color: 'white',
    borderRadius: '50%',
    width: '22px',
    height: '22px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '12px',
    fontWeight: 'bold',
  },
  notificacoesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  notificacaoItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '12px',
    padding: '15px',
    borderRadius: '12px',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    borderLeft: '4px solid',
  },
  notificacaoNaoLida: {
    backgroundColor: '#EBF8FF',
    borderLeftColor: '#3182CE',
  },
  notificacaoLida: {
    backgroundColor: '#F7FAFC',
    borderLeftColor: '#A0AEC0',
  },
  notificacaoContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    flex: 1,
    flexWrap: 'wrap',
  },
  notificacaoDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    flexShrink: 0,
  },
  notificacaoTexto: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    color: '#2D3748',
    flex: 1,
    fontWeight: '500',
  },
  notificacaoTime: {
    fontSize: '12px',
    color: '#718096',
    fontFamily: 'Montserrat, sans-serif',
  },
  fecharButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '6px',
    borderRadius: '6px',
    transition: 'background-color 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '28px',
    height: '28px',
    flexShrink: 0,
  },
  fecharX: {
    color: '#E53E3E',
    fontSize: '20px',
    fontWeight: 'bold',
    lineHeight: '1',
  },
  semNotificacoes: {
    textAlign: 'center',
    color: '#718096',
    fontStyle: 'italic',
    padding: '30px 20px',
    fontFamily: 'Montserrat, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '10px',
  },
  verMaisContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '15px',
    paddingTop: '15px',
    borderTop: '1px solid #E2E8F0',
  },
  verMaisButton: {
    background: 'none',
    border: '1px solid #1A3B7D',
    color: '#1A3B7D',
    padding: '8px 16px',
    borderRadius: '20px',
    cursor: 'pointer',
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    fontWeight: '500',
    transition: 'all 0.2s ease',
  },
  gridContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: '30px',
  },
  userInfo: {
    display: 'flex',
    justifyContent: 'center',
    padding: '0 20px',
  },
  userCard: {
    backgroundColor: '#fff',
    borderRadius: '12px',
    padding: '20px',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.08)',
    border: '1px solid #e2e8f0',
    maxWidth: '400px',
    width: '100%',
  },
  userInfoItem: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: '14px',
    color: '#4A5568',
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

// Efeitos hover
styles.fecharButton[':hover'] = {
  backgroundColor: '#FED7D7',
};

styles.verMaisButton[':hover'] = {
  backgroundColor: '#1A3B7D',
  color: 'white',
};

styles.notificacaoItem[':hover'] = {
  transform: 'translateY(-2px)',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
};

export default InterfaceAssociados;